import { ContactInfosComponent } from './contact-infos/contact-infos.component';
import { ContactComponent } from './contact.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {HttpModule} from '@angular/http';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';


import { SharedModule } from '../shared/shared.module';
import { ContactService } from './contact.service';


@NgModule({
	imports: [
		BrowserModule,
		CommonModule,
		HttpModule,
		ReactiveFormsModule,
		RouterModule,
		SharedModule,
	],
	declarations: [
		ContactComponent,
		ContactInfosComponent
	],
	exports: [
		ContactInfosComponent
	],
	providers: [
		ContactService
	],
})
export class ContactModule {}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/contact/contact.module.ts